import LoginContainer from 'modules/accountManagement/containers/LoginContainer';

const SignUpView = () => <LoginContainer isSignUp />;

export default SignUpView;
